module.exports = __webpack_public_path__ + "img/base.56f94597.png";